<div style="width:100%">
  <!-- <div class="header thin-header mat-accent-bg p-12 p-sm-24" fxLayout="row" fxLayoutAlign="start start"
    fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="row">

    <div fxFlex="" fxLayoutAlign="start center">

      <span class="logo-text h1">Review</span>

    </div>
    <div fxFlex fxLayoutAlign="end center">

    </div>

  </div> -->
  <br>
  <div style="width: 100%; height: 100%; overflow: auto">

    <div class="mdl-grid">

      <div class="mdl-cell mdl-cell--12-col" [ngClass] *ngIf="onlyOnePdf">
        <p style="font-size: 18px; font-weight: 500; text-align: center">Generated Form</p>
        <iframe id="first" [src]="firstUrl"
          style="min-height: 585px; min-width:500px; width: 100%; height: 100%"></iframe>
      </div>

      <div class="mdl-cell mdl-cell--6-col" *ngIf="!onlyOnePdf">
        <p style="font-size: 18px; font-weight: 500; text-align: center">Generated Form</p>
        <iframe id="first" [src]="firstUrl"
          style="min-height: 585px; min-width:500px; width: 100%; height: 100%"></iframe>

      </div>

      <!-- <div class="mdl-cell" [ngClass] = "{'mdl-cell--6-col': onlyOnePdf, 'mdl-cell--12-col' : onlyOnePdf }">
        <p style="font-size: 15px; font-weight: 500; text-align: center">Generated Form</p>
        <iframe id="first" [src]="firstUrl"
          style="min-height: 585px; min-width:500px; width: 100%; height: 100%"></iframe>
      </div> -->

      <div class="mdl-cell mdl-cell--6-col" *ngIf="!onlyOnePdf">
        <p style="font-size: 18px; font-weight: 500; text-align: center">Uploaded Form</p>
        <iframe id="signed" [src]="firstUrl"
          style="min-height: 585px; min-width:500px; width: 100%; height: 100%"></iframe>
      </div>

    </div>

    <br /><br />
    <div style="width: 100%; text-align: center" [ngClass] *ngIf="inventoryPdf">
      <mat-form-field class="example-full-width">
        <input matInput [(ngModel)]="inventoryFees" type="number" name="inventoryFees" (ngModelChange)="checkModel(inventoryFees)"
            placeholder="Inventory Fees">
        <mat-icon matPrefix>monetization_on</mat-icon>
      </mat-form-field>
    </div>

    <div style="width: 100%; text-align: center">
      <button [class.loading]="isLoadingApprove" mat-raised-button color="accent" (click)="approvePDF(true);"
        [disabled]="isLoadingApprove || disableButton">
        <div class="spinner"></div>
        <span class="label">APPROVE</span>
      </button>
      <button [class.loading]="isLoadingDeny" mat-raised-button color="warn" (click)="declinePDF(false);"
        [disabled]="isLoadingDeny || isLoadingApprove || disableButton">
        <div class="spinner"></div>
        <span class="label">DENY</span>
      </button>
    </div>

    <br /><br />

    <div style="width: 100%; text-align: center"  *ngIf="!onlyOnePdf">
      <button [class.loading]="isLoadingDiff" mat-raised-button color="accent" (click)="getDetailedPDfDifferences();"
        [disabled]="isLoadingDiff" *ngIf="pdfDifferences.data.length > 0">
        <div class="spinner"></div>
        <span class="label" style="text-transform: uppercase">{{showDetailedDifferences ? 'Hide' : 'Show'}} Detailed
          Differences</span>
      </button>
    </div>

    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--12-col" [hidden]="!showDetailedDifferences">
        <div style="margin-bottom: 10px">
          <strong>Detailed Form Differences</strong>
        </div>
        <mat-table [dataSource]="pdfDifferences" class="mat-elevation-z8">
          <ng-container matColumnDef="label">
            <mat-header-cell *matHeaderCellDef> Label </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.label}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="pdfValue">
            <mat-header-cell *matHeaderCellDef> Generated Form </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.dbValue }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dbValue">
            <mat-header-cell *matHeaderCellDef> Uploaded Form </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.pdfValue }} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
      </div>
    </div>

    <br />
    <br />
    <div class=" commentSection" *ngIf="!onlyOnePdf">
      <comments [mode]="'hello'" [orgId]="org" [caseId]="commentId"></comments>
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/pdfView/pdfView.component.html